import { AxiosRequestConfig } from 'axios'
import {
  getAddBuyerParams,
  getBuyerParams,
  getHeaderParams,
  getRemoveBuyerParams
} from 'helpers/requestParams'
import apiEndpoints from 'const/endPoint'
import apiRequestor from 'services/apiRequestor'
import { BuyerInfoState } from 'typings/reduxStore'
import { BuyerParams } from 'typings/apiRequest'
import {
  AddBuyerRequest,
  AddBuyerResponse,
  DeleteBuyerRequest,
  EditBuyerRequest,
  EditBuyerResponse,
  GetBuyerListSuccessResponse,
  OrderReplacementCardsResponse
} from 'typings/buyer'

const buyerAPI = {
  getBuyers: async (
    payload: BuyerInfoState
  ): Promise<GetBuyerListSuccessResponse> => {
    const { accessToken } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.authBuyerSummary,
      method: 'POST',
      headers: { ...headerParams },
      data: getBuyerParams(payload as BuyerParams)
    }

    const response = await apiRequestor<GetBuyerListSuccessResponse>({
      requestConfig
    })

    return response.data
  },
  addBuyer: async (payload: AddBuyerRequest): Promise<AddBuyerResponse> => {
    const { accessToken } = payload

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.authBuyer,
      method: 'POST',
      headers: { ...getHeaderParams(accessToken), loginUser: 'ESERVICE' },
      data: getAddBuyerParams(payload)
    }

    const response = await apiRequestor<AddBuyerResponse>({
      requestConfig
    })

    return response.data
  },
  deleteBuyer: async (
    payload: DeleteBuyerRequest
  ): Promise<EditBuyerResponse> => {
    const { accessToken } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.authBuyerProfile,
      method: 'POST',
      headers: { ...headerParams },
      data: getRemoveBuyerParams(payload)
    }

    const response = await apiRequestor<EditBuyerResponse>({
      requestConfig
    })

    return response.data
  },
  editBuyer: async (payload: EditBuyerRequest): Promise<EditBuyerResponse> => {
    const { accessToken, buyerInfo } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.authBuyerProfile,
      method: 'POST',
      headers: { ...headerParams },
      data: { ...buyerInfo }
    }

    const response = await apiRequestor<EditBuyerResponse>({
      requestConfig
    })

    return response.data
  },
  orderReplacementCards: async (
    payload: BuyerInfoState
  ): Promise<OrderReplacementCardsResponse> => {
    const {
      accessToken,
      authBuyer: buyers,
      accountNumber,
      lostOrStolen
    } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.authBuyerProfile,
      method: 'POST',
      headers: { ...headerParams },
      data: {
        'cipher.accountId': accountNumber,
        authBuyer: buyers,
        lostOrStolen
      }
    }

    const response = await apiRequestor<OrderReplacementCardsResponse>({
      requestConfig
    })

    return response.data
  }
}

export default buyerAPI
